import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import API from "../../../api.js";
import { listDoctors } from "../../../Redux/actions/adminActions/doctorActions.js";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../Loading.jsx";
import Error from "../../Error.jsx";

const AssignAppointmentModal = ({ show, onHide, appointment, onAssign }) => {
  const dispatch = useDispatch();
  const { loading, error, doctors } = useSelector(
    (state) => state.adminDoctors || {}
  );
  const [doctor, setDoctors] = useState([]);
  const [doctorId, setDoctorId] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");

  // Load all doctors once (if not already loaded)
  useEffect(() => {
    dispatch(listDoctors());
  }, [dispatch]);

  // Filter doctors by appointment.department
  useEffect(() => {
    if (!appointment || !doctors) return;

    const matched = doctors.filter(
      (doc) => doc.department === appointment.department
    );

    setDoctors(matched);
  }, [appointment, doctors]);

  const handleSubmit = () => {
    if (!doctorId || !date || !time) return alert("All fields required");
    onAssign({ doctorId, date, time });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Assign Appointment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && <Loading />}
        {error && <Error message={error} />}
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Doctor</Form.Label>
            <Form.Select
              value={doctorId}
              onChange={(e) => setDoctorId(e.target.value)}
            >
              <option value="">Select Doctor</option>
              {doctor.map((doc) => (
                <option key={doc._id} value={doc._id}>
                  {doc.name} ({doc.specialization})
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Date</Form.Label>
            <Form.Control
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Time</Form.Label>
            <Form.Control
              type="time"
              value={time}
              onChange={(e) => setTime(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="success" onClick={handleSubmit}>
          Assign & Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AssignAppointmentModal;
